import * as Dialog from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';

/**
 * A full sheet, as the phone presents Set out: it rises from the bottom edge on
 * a phone-width window and stands centred and tall on a wider one. Radix
 * supplies the dialog role, focus trap, scroll lock and Escape. Unlike
 * `Modal`, the caller places its own title — with `SheetTitle` — because the
 * sheet's heading is drawn inside its scene.
 */
export function Sheet({
  onClose,
  busy = false,
  className,
  children,
}: {
  onClose: () => void;
  busy?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Dialog.Root
      open
      onOpenChange={next => {
        if (!next && !busy) {
          onClose();
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="ui-sheet-backdrop">
          <Dialog.Content
            aria-describedby={undefined}
            tabIndex={-1}
            // The sheet itself takes focus, so arriving does not ring its Close.
            onOpenAutoFocus={event => {
              event.preventDefault();
              (event.currentTarget as HTMLElement | null)?.focus();
            }}
            className={className ? `ui-sheet ${className}` : 'ui-sheet'}
            onEscapeKeyDown={event => {
              if (busy) {
                event.preventDefault();
              }
            }}
            onPointerDownOutside={event => event.preventDefault()}
            onInteractOutside={event => event.preventDefault()}
          >
            {children}
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export const SheetTitle = Dialog.Title;
export const SheetClose = Dialog.Close;
